import { renderInDocument } from '@spotahome/soyuz/client';

import HowItWorksContainer from './main';

renderInDocument(HowItWorksContainer);
